export interface DatedMatch {
  occurredAt?: string | null;
  tournamentNumber?: number | null;
}

// A tournament's file number used to double as its place in time: bigger number,
// later match. A kolejka closed in the panel breaks that — it projects a
// tournament numbered -roundId, which sorts below every ingested file and pushes
// the newest matches to the bottom of the list. Time comes from occurredAt now;
// the file number is only a tie-breaker for rows that predate it.
export function byNewestFirst(a: DatedMatch, b: DatedMatch): number {
  const timeA = matchTime(a);
  const timeB = matchTime(b);

  if (timeA !== timeB) {
    return timeB - timeA;
  }

  return (b.tournamentNumber ?? 0) - (a.tournamentNumber ?? 0);
}

export function byOldestFirst(a: DatedMatch, b: DatedMatch): number {
  return byNewestFirst(b, a);
}

function matchTime(match: DatedMatch): number {
  if (!match.occurredAt) {
    return 0;
  }

  const parsed = Date.parse(match.occurredAt);

  return Number.isNaN(parsed) ? 0 : parsed;
}
